import styled, { css } from 'styled-components';
import { Stack } from '@mui/material';
import { flex } from './Flex';

export const flexColumn = css`
  ${flex};
  flex-direction: column;
`;

export const FlexColumn = styled(Stack)``;
